// Constantes de estilo compartidas por las variantes del sidebar.
export const PRIMARY_SOFT = 'rgba(13, 71, 161, 0.08)'; // hover de ítems de navegación
export const PRIMARY_SOFTER = 'rgba(13, 71, 161, 0.06)'; // fondo saldos / hover encabezados
export const ERROR_SOFT = 'rgba(211, 47, 47, 0.08)'; // hover del botón cerrar sesión

// Estilo base de un ítem de navegación (link) del sidebar.
export const navItemSx = {
  borderRadius: 2,
  mx: 1,
  width: 'auto',
  transition: 'all 0.15s ease-in-out',
  '&:hover': {
    backgroundColor: PRIMARY_SOFT,
    transform: 'translateX(4px)',
  },
};

// Hover en rojo para la acción de cerrar sesión.
export const dangerItemSx = {
  ...navItemSx,
  '&:hover': { ...navItemSx['&:hover'], backgroundColor: ERROR_SOFT },
};

// Estilo del encabezado colapsable (Menú y cada categoría).
export const categoryHeaderSx = {
  px: 2.5,
  py: 0.75,
  '&:hover': { backgroundColor: PRIMARY_SOFTER },
};

export const categoryLabelSx = {
  flexGrow: 1,
  color: 'text.secondary',
  fontWeight: 700,
  lineHeight: 1.2,
  fontSize: '0.95rem',
};

// Tamaño de fuente de los ítems de navegación.
export const NAV_ITEM_FONT_SIZE = '1.1rem';
